export const getUserTableColumn = (typeBusiness) => [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 60,
  },
  {
    title: "Correo",
    dataIndex: "username",
    key: "login",
    width: 250,
    ellipsis: true,
  },
  {
    title: "Nombre y Apellido",
    dataIndex: "fullname",
    key: "fullname",
    slots: { customRender: "fullname" },
    width: 320,
    ellipsis: true,
  },
  {
    dataIndex: "profile_name",
    key: "perfilONivel",
    slots: { customRender: "perfilONivel" },
    sorter: (a, b) => {
      if (a.profile_name < b.profile_name) return -1;
      if (a.profile_name > b.profile_name) return 1;
      return 0;
    },
    width: 200,
  },
  {
    title: "Anexo",
    dataIndex: "annex",
    key: "anexo",
    width: 120,
  },
  {
    dataIndex: "status",
    key: "status",
    slots: { customRender: "statusScoped" },
    sorter: (a, b) => a.status - b.status,
    width: 120,
  },

  ...(typeBusiness === 1
    ? [
        {
          dataIndex: "company",
          key: "entity",
          slots: { customRender: "company" },
          title: "Empresas",
          width: 160,
        },
      ]
    : []),
  // {
  //   dataIndex: "company",
  //   title: "Empresas",
  //   key: "entity",
  //   slots: { customRender: "company" },
  //   width: 160,
  // },
  {
    dataIndex: "cartera",
    title: "Campañas",
    key: "carteras",
    slots: { customRender: "cartera" },
    width: 160,
  },
  {
    title: "Acciones",
    key: "action",
    slots: { customRender: "actionScoped" },
    fixed: "right",
    width: 100,
  },
];
